<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">REAJUSTAR VALOR DOS ABASTECIMENTOS:</h3>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    :items="[
                      'PELAS DATAS SOMENTE',
                      'DATAS E INTERVALO DE HORAS',
                    ]"
                    v-model="itemNewValues.filterOption"
                  />
                </v-col>
                <v-row v-if="itemNewValues.filterOption == 'DATAS E INTERVALO DE HORAS'">
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field
                      label="hora"
                      v-mask="'00:00'"
                      placeholder="Digite a hora inicial"
                      v-model="itemNewValues.startHour"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field
                      label="hora"
                      v-mask="'00:00'"
                      placeholder="Digite a hora final"
                      v-model="itemNewValues.endHour"
                    />
                  </v-col>
                </v-row>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="itemNewValues.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    clearable
                    @change="[getProviders()]"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    v-model="itemNewValues.provider_id"
                    label="Participante"
                    :items="providers"
                    item-text="provider_name"
                    item-value="provider_id"
                    clearable
                    @change="getItems"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    label="Item:"
                    :items="items"
                    item-value="item_id"
                    item-text="item_name"
                    v-model="itemNewValues.item_id"
                    @change="getItemValue(itemNewValues.item_id)"
                  >
                    <template slot="selection" slot-scope="{ item }"
                      >{{ item.item_description_desc }} preço R$:
                      {{ realMaskII(item.item_price.toFixed(3)) }}</template
                    >
                    <template slot="item" slot-scope="{ item }"
                      >{{ item.item_description_desc }} preço R$:
                      {{ realMaskII(item.item_price.toFixed(3)) }}</template
                    >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Valor Atual"
                    v-mask-decimal.br="3"
                    v-model="itemNewValues.itemCurrentValue"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Novo Valor"
                    v-mask-decimal.br="3"
                    v-model="itemNewValues.itemNewValue"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-checkbox
                    label="Alterar valor do item na licitação?"
                    v-model="itemNewValues.newValueBidding"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <br />
          <v-footer absolute rounded>
            <v-btn text :loading="loader"></v-btn>
            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-2"
              text
              @click="readjustValues"
              :disabled="
                itemNewValues.startDate &&
                itemNewValues.endDate &&
                itemNewValues.prefecture_id &&
                itemNewValues.item_id &&
                itemNewValues.provider_id &&
                itemNewValues.itemNewValue
                  ? false
                  : true
              "
              >APLICAR REAJUSTE</v-btn
            >
          </v-footer>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    secretariats: [],
    providers: [],
    items: [],
    itemNewValues: {
      itemCurrentValue: 0,
      itemNewValue: 0,
      newValueBidding: false,
      item_id: null,
      prefecture_id: null,
      provider_id: null,
      startDate: null,
      endDate: null,
      startHour: "",
      endHour: "",
      filterOption: "PELAS DATAS SOMENTE",
    },
    dataSupplies: [],
    selectedSupplies: [],
    headers: [
      { text: "Data/Hora", value: "datehour", sortable: false },
      { text: "Item", value: "item_description_desc", sortable: false },
      {
        text: "Litros Abastecidos",
        value: "supply_liters_stocked",
        sortable: false,
      },
      {
        text: "Valor",
        value: "supply_price_day",
        sortable: false,
      },
      { text: "Total", value: "supply_value", sortable: false },
      { text: "Senha", value: "supply_code", sortable: false },
      { text: "Status", value: "supply_status", sortable: false },
      { text: "Corrigido", value: "supply_ajusted", sortable: false },
      { text: "Faturado", value: "supply_billed", sortable: false },
    ],
    loader: false,
    resultAverage: null,
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getProviders() {
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/readjust/providers/${this.itemNewValues.prefecture_id}`)
        .then((r) => {
          this.providers = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getItems() {
      this.itemNewValues.vehicle_id = null;
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
      .get(`/supplies/providers/prefectures/${this.itemNewValues.provider_id}/${this.itemNewValues.prefecture_id}/${this.itemNewValues.startDate}/${this.itemNewValues.endDate}`).then((r) => {
          this.items = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getItemValue(id) {
      const items = [...this.items];
      const item = items.find((item) => item.item_id == id);
      this.itemNewValues.itemCurrentValue = item.item_price.toFixed(3);
    },
    emptyValues() {
      this.itemNewValues.itemCurrentValue = 0;
      this.itemNewValues.itemNewValue = 0;
      this.itemNewValues.item_id = null;
      this.itemNewValues.prefecture_id = null;
      this.itemNewValues.provider_id = null;
      this.itemNewValues.startDate = null;
      this.itemNewValues.endDate = null;
      this.itemNewValues.startHour = null;
      this.itemNewValues.endHour = null;
      this.itemNewValues.filterOption = 'PELAS DATAS SOMENTE';
    },
    getData() {
      if (this.itemNewValues.prefecture_id) {
        this.dataSupplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/distribution/econferences/data`, this.itemNewValues)
          .then((supplies) => {
            this.dataSupplies = supplies.data;
            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    readjustValues() {
      let c = confirm("Essa operação não poderá ?");
      if (c) {
        this.$http
          .put("/readjust", this.itemNewValues)
          .then((r) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.emptyValues();
            this.snack.type = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>